import * as React from 'react';
import './AccountPickerHeader.scss';

import AccountPicker, {
  IAccountPickerStateProps,
  IAccountPickerDispatchProps,
} from './AccountPicker';

export interface IAccountPickerHeaderStateProps
  extends IAccountPickerStateProps {
  isAuthenticated: boolean;
  adaptiveSuperUser: boolean;
}

const AccountPickerHeader: React.FC<
  IAccountPickerHeaderStateProps &
    IAccountPickerDispatchProps &
    IAccountPickerStateProps
> = ({
  isAuthenticated,
  accounts,
  accountId,
  selectAccountId,
  adaptiveSuperUser,
}) => {
  return isAuthenticated && adaptiveSuperUser ? (
    <div className='account-picker-header'>
      <div className='container'>
        <div className='row'>
          <div className='col-auto'>
            <AccountPicker
              accountId={accountId}
              accounts={accounts}
              selectAccountId={selectAccountId}
            />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default AccountPickerHeader;
